<section class="container portrait-loader">
    <div class="box portrait-loader__box">
        <div class="box__content portrait-loader__box-content">
            <img class="portrait-loader__hourglass" src="{{ errorImg }}" alt="hourglass">
            <h2 class="text text_type_h2 text_accented">Transaction error!</h2>
        </div>
    </div>
</section>